import React from 'react';
import parse from 'html-react-parser';
import { COMPANY_NAME } from '../../constants/brand';

export default function TextWidget({ logoUrl, text }) {
  return (
    <div className="cs_text_widget">
      {logoUrl && <img src={logoUrl} alt={COMPANY_NAME} />}
      {text && <p className="cs_medium">{parse(text)}</p>}
    </div>
  );
}
